// HOOKS
import { useContext } from "react";
// COMPONENTS
import ActionBar from "../../actionBar.component";
import CreatePermissionsButton from "../../../buttons/admin/users/createPermissionsButton.users.admin.button";
// CONTEXTS
import { PermissionsContext } from "../../../../contexts/users/permissions/permissions.user.context";

const PermissionActionBar = ({ children }) => {
  const { fetchPermissions } = useContext(PermissionsContext);
  return (
    <ActionBar>
      <CreatePermissionsButton onClose={fetchPermissions} />
      {children}
    </ActionBar>
  );
};

export default PermissionActionBar;
